import { ReactNode } from "react"
import { Table as Tab } from "flowbite-react"
import cn from "classnames"

interface ITableBody {
  children: ReactNode
  className?: string
}

const TableBody = ({ children, className }: ITableBody) => {
  return <Tab.Body className={cn("divide-x divide-y border-2", className)}>{children}</Tab.Body>
}

export default TableBody
